<div [ngxSummernoteView]="landingContent" class="product-family-content"></div>
